import { render, staticRenderFns } from "./MethodStep.vue?vue&type=template&id=ec8961e4&scoped=true&"
import script from "./MethodStep.vue?vue&type=script&lang=js&"
export * from "./MethodStep.vue?vue&type=script&lang=js&"
import style0 from "./MethodStep.vue?vue&type=style&index=0&id=ec8961e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8961e4",
  null
  
)

export default component.exports